import React, {useState} from "react";
import NewRateCard from "./NewRateCard";
import { Box, Column, Columns, Pagination, Table, Title } from "@allxsmith/bestax-bulma";
import axios from "axios";
import {ToastContainer, toast} from "react-toastify";
import {useRateCardsData} from "../../../hooks/useRateCardsData";
import {getDataFresh, getRateCardsData} from "../../../state/selectors";
import {useDispatch, useSelector} from "react-redux";
import LoadingSpinner from "../../Utils/Spinner";
import RateCardRow from "./RateCardRow";
import {createSetDataFreshAction, createSetRateCardsDataAction} from "../../../actions/dataActions";
import FilterBlankHeading from "../../Invoicing/FilterBlankHeading";
import FilterHeading from "../../Invoicing/FilterHeading";
import PaginationWrapper from "../../Utils/PaginationWrapper";


export default function RateCard(props){
    const dispatch = useDispatch();
    const dataFresh = useSelector(getDataFresh);
    const [page, setPage] = useState(1);
    const [filters, setFilters] = useState({});

    let params = {page, show_hide:true};

    for (let filter in filters) {
        if (filters[filter][0] && filters[filter][0][filter]) {
          params[filter] = filters[filter][0][filter];
        }
    }

    const headings = [
        {
            label: "Name",
            field:"name",
            labelField:"name"
        },
        {
            label: "Day 1-2 Rate"
        },
        {
            label: "Day 3-6 Rate"
        },
        {
            label: "Day 7-27 Rate"
        },
        {
            label: "Day 28+ Rate"
        },
        {
            label: "Insurance Charge (%)"
        },
        {
            label: "Admin Charge (%)"
        },
        {
            label: "Description"
        },
        {
            label: "Customer",
            field: "contact",
            labelField: "contact__display_name"
        },
        {
            label: "Hide"
        }
    ]

    const ratesLoaded = useRateCardsData(params, dataFresh);
    const data = useSelector(getRateCardsData);

    const onChange = (e, index) => {
        let newResults = [...data.results];
        let newRateCards = {...data, results: newResults};
        let newRateCard = {...data.results[index], [e.target.name]: e.target.value};
        newRateCards.results[index] = newRateCard
        dispatch(createSetRateCardsDataAction(newRateCards));
    }


    const onSave = (data, callback) => {
        let url = props.endpoint+"ratecard"
        let method;
        if(data.id){
            url = url+"/"+data.id;
            method = "put"
        }
        else{
            method = "post"
        }
        const conf = {
            url: url,
            data: data,
            method: method
        };
        axios(conf).then(res => {
            dispatch(createSetDataFreshAction(dataFresh + 1));
            toast.success(`Successfully ${method === "put" ? "Saved" : "Created"} rate card`, {position: "top-right"});
            callback();
        }).catch(err => {
            console.log(err);
            toast.error("There was an error saving", {position: "top-right"});
        })
    }

    if(!ratesLoaded){
        return (
            <LoadingSpinner/>
        )
    }

    // TODO(bestax-migrate): `showFirstLast` — no showFirstLast prop in bestax Pagination
    return (
        <div>
            <br/>
            <NewRateCard save={onSave}/>
            <Box>
                <details>
                    <summary><Title>Rental Rate Card</Title></summary>
                    <Columns isMultiline>
                        <Column>
                            <Table isFullwidth>
                                <thead>
                                    <tr>
                                        {headings.map(heading => {
                                            if (!heading.field) {
                                              return <th key={heading.label}>{heading.label}</th>;
                                            }
                                            if (heading.blank) {
                                              return (
                                                <FilterBlankHeading
                                                  key={heading.label}
                                                  heading={heading}
                                                  setFilters={f => {
                                                    setPage(1);
                                                    setFilters(f);
                                                  }}
                                                  filters={filters}
                                                />
                                              );
                                            }
                                            return (
                                              <FilterHeading
                                                key={heading.label}
                                                heading={heading}
                                                setFilters={f => {
                                                  setPage(1);
                                                  setFilters(f);
                                                }}
                                                filters={filters}
                                                options={data.filter_list[heading.field]}
                                              />
                                            );
                                        })}
                                    </tr>
                                </thead>
                                <tbody>
                                {data.results.map((rate,index) => (
                                    <RateCardRow
                                        rateCard={rate}
                                        onSave={onSave}
                                        onChange={onChange}
                                        index={index}
                                    />
                                ))}
                                </tbody>
                            </Table>
                        </Column>
                    </Columns>
                    <PaginationWrapper
                        setPage={setPage}
                        page={page}
                        dataCount={Math.ceil(data.count / 25)}
                    />
                </details>
            </Box>
        </div>
    );


}